/**
 * What's On Map
 * Interactive map showing event locations with clustering
 */
(function() {
    const SECTION_COLORS = {
        theatreEvents: '#C247FF',
        workshops: '#FFA800',
        festivalEvents: '#17E58F'
    };

    const SECTION_LABELS = {
        theatreEvents: 'Theatre Event',
        workshops: 'Workshop',
        festivalEvents: 'Festival Event'
    };

    const HEADING_MAP = {
        all: 'Barking Gecko Roadmap',
        theatreEvents: 'Theatre Roadmap',
        workshops: 'Workshops Roadmap',
        festivalEvents: 'Festival Roadmap',
        past: 'Previous Events'
    };

    const PAST_HEADING_MAP = {
        all: 'All Previous Events',
        theatreEvents: 'Previous Theatre Events',
        workshops: 'Previous Workshops',
        festivalEvents: 'Our Previous Festival Events'
    };

    function cartoKeyParam() {
        const key = (window.siteConfig && window.siteConfig.cartoApiKey) || '';
        return key ? '?key=' + encodeURIComponent(key) : '';
    }

    function escapeHtml(text) {
        if (!text) return '';
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    function initWhatsOnMap() {
        if (typeof L === 'undefined') {
            setTimeout(initWhatsOnMap, 50);
            return;
        }

        const mapEl = document.getElementById('whats-on-leaflet-map');
        if (!mapEl) return;

        const markerSvg = mapEl.dataset.markerSvg || '';
        const showPast = mapEl.dataset.showPast === 'true';
        const allData = window.whatsOnMapData || [];

        if (!allData.length || !markerSvg) {
            const panel = mapEl.closest('#whatsOnMapPanel');
            if (panel) panel.style.display = 'none';
            return;
        }

        function createIcon(section, faded) {
            const color = SECTION_COLORS[section] || '#C247FF';
            const svg = markerSvg.replace(/__COLOR__/g, color);
            return L.divIcon({
                html: '<div class="bga-marker-bounce" style="line-height:0;opacity:' + (faded ? '0.65' : '1') + '">' + svg + '</div>',
                iconSize: [35, 35],
                iconAnchor: [17, 35],
                popupAnchor: [0, -35],
                className: ''
            });
        }

        const map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true });

        L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png' + cartoKeyParam(), {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: 'abcd',
            maxZoom: 20
        }).addTo(map);

        // Cluster icon uses the same marker SVG but in gray
        const clusterSvg = markerSvg.replace(/__COLOR__/g, '#6B7280');

        function createClusterIcon(count) {
            return L.divIcon({
                html: '<div class="bga-cluster-icon">' +
                    clusterSvg +
                    '<span class="bga-cluster-count">' + count + '</span>' +
                    '</div>',
                iconSize: [44, 44],
                iconAnchor: [22, 22],
                className: ''
            });
        }

        // Cluster group with brand-styled cluster icons
        const clusterGroup = L.markerClusterGroup({
            maxClusterRadius: 50,
            iconCreateFunction: function(cluster) {
                return createClusterIcon(cluster.getChildCount());
            }
        });

        // Arrow icon SVG for popup links
        const arrowIcon = '<svg class="bga-popup-link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';

        // Build marker instances keyed by event id
        const markerMap = {};
        allData.forEach(function(event) {
            const marker = L.marker([event.lat, event.lng], { icon: createIcon(event.section, event.isPast && showPast) });
            const sectionLabel = SECTION_LABELS[event.section] || 'Event';
            const typeLabel = event.isPast ? 'Past ' + sectionLabel : sectionLabel;
            const popupContent = '<div class="bga-popup-inner">' +
                '<span class="bga-popup-type">' + escapeHtml(typeLabel) + '</span>' +
                '<span class="bga-popup-title">' + escapeHtml(event.title) + '</span>' +
                '<a href="' + escapeHtml(event.url) + '" class="bga-popup-link">View ' + escapeHtml(sectionLabel) + ' ' + arrowIcon + '</a>' +
                '</div>';
            marker.bindPopup(
                popupContent,
                { className: 'bga-map-popup bga-map-popup--' + event.section, maxWidth: 260 }
            );
            markerMap[event.id] = { marker: marker, data: event };
            clusterGroup.addLayer(marker);
        });

        map.addLayer(clusterGroup);

        // Initial fit bounds
        const allLatLngs = allData.map(function(e) { return [e.lat, e.lng]; });
        const boundsOptions = { padding: [40, 40], maxZoom: 12 };

        map.invalidateSize();
        map.fitBounds(allLatLngs, boundsOptions);

        setTimeout(function() {
            map.invalidateSize();
            map.fitBounds(allLatLngs, boundsOptions);
        }, 200);

        // Re-fit when map becomes visible
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        map.invalidateSize();
                        map.fitBounds(allLatLngs, boundsOptions);
                        observer.disconnect();
                    }
                });
            }, { threshold: 0.1 });
            observer.observe(mapEl);
        }

        // Heading + Legend elements
        const headingEl = document.getElementById('whatsOnMapHeading');
        const legendEl = document.getElementById('whatsOnMapLegend');

        function buildLegendItem(section, label, faded) {
            var color = SECTION_COLORS[section] || '#C247FF';
            return '<span class="bga-map-legend-item' + (faded ? ' bga-map-legend-item--faded' : '') + '">' +
                '<span class="bga-map-legend-swatch" style="background:' + color + (faded ? ';opacity:0.65' : '') + '"></span>' +
                escapeHtml(label) +
                '</span>';
        }

        function updateHeadingAndLegend(eventType, pastEventType) {
            // Update heading
            if (headingEl) {
                if (eventType === 'past') {
                    headingEl.textContent = PAST_HEADING_MAP[pastEventType] || 'Past Events';
                } else {
                    headingEl.textContent = HEADING_MAP[eventType] || 'All Events';
                }
            }

            // Update legend
            if (!legendEl) return;
            var items = '';

            if (eventType === 'all') {
                // Show all types + faded past variants
                items += buildLegendItem('theatreEvents', 'Theatre');
                items += buildLegendItem('workshops', 'Workshops');
                items += buildLegendItem('festivalEvents', 'Festival');
                if (showPast) {
                    items += buildLegendItem('theatreEvents', 'Previous Theatre', true);
                    items += buildLegendItem('workshops', 'Previous Workshops', true);
                    items += buildLegendItem('festivalEvents', 'Previous Festival', true);
                }
            } else if (eventType === 'past') {
                // Past events view
                if (pastEventType === 'all') {
                    items += buildLegendItem('theatreEvents', 'Previous Theatre');
                    items += buildLegendItem('workshops', 'Previous Workshops');
                    items += buildLegendItem('festivalEvents', 'Previous Festival');
                } else {
                    items += buildLegendItem(pastEventType, SECTION_LABELS[pastEventType] || 'Event');
                }
            } else {
                // Single category — show current + faded past variant if past markers visible
                items += buildLegendItem(eventType, SECTION_LABELS[eventType] || 'Event');
                if (showPast) {
                    items += buildLegendItem(eventType, 'Previous ' + (SECTION_LABELS[eventType] || 'Event'), true);
                }
            }

            legendEl.innerHTML = items;
        }

        // Set initial state
        updateHeadingAndLegend('all', 'all');

        // Sync with filter changes
        document.addEventListener('whatsOnFiltered', function(e) {
            const visibleIds = e.detail.visibleIds;
            const visiblePastIds = e.detail.visiblePastIds;

            // Update heading + legend
            updateHeadingAndLegend(e.detail.currentEventType, e.detail.currentPastEventType);

            clusterGroup.clearLayers();
            const boundsLatLngs = [];

            allData.forEach(function(event) {
                const inVisible = visibleIds.includes(event.id);
                const inVisiblePast = visiblePastIds.includes(event.id);

                let show = false;
                let faded = false;

                if (!event.isPast) {
                    show = inVisible;
                } else if (showPast) {
                    if (inVisible) {
                        show = true;
                        faded = false;
                    } else if (inVisiblePast) {
                        show = true;
                        faded = true;
                    }
                }

                if (!show) return;

                markerMap[event.id].marker.setIcon(createIcon(event.section, faded));
                clusterGroup.addLayer(markerMap[event.id].marker);
                boundsLatLngs.push([event.lat, event.lng]);
            });

            if (boundsLatLngs.length) {
                map.fitBounds(boundsLatLngs, { padding: [40, 40], maxZoom: 12 });
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initWhatsOnMap);
    } else {
        initWhatsOnMap();
    }
})();

